import React from 'react';
import { useParams, Link } from 'react-router-dom';
import members from '../data/members';
import { useEffect } from 'react';
import './MemberDetail.css';

export default function MemberDetail() {
  const { id } = useParams();
  const member = members.find(m => m.id === id);
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  if (!member) {
    return (
      <div className="detail">
        <p>Jäsentä ei löytynyt.</p>
        <Link to="/">← Takaisin</Link>
      </div>
    );
  }
  return (
    <div className="detail">
      <div className="detail-header">
        <h2>{member.name}</h2>
        <h4>{member.instrument}</h4>
      </div>

      <div className="detail-body">
        <img src={member.detailImage} alt={member.name} className="detail-img" />
        <div className="detail-content">
        {member.bio.split('\\n\\n').map((paragraph, index) => (
        <p key={index}>{paragraph}</p>
        ))}
        </div>
      </div>
    </div>

    /*<div className="detail">
      <Link to="/" className="back">← Takaisin etusivulle</Link>
      <img src={member.detailImage} alt={member.name} className="detail-img"/>
      <h2>{member.name}</h2>
      <h4>{member.instrument}</h4>
      {member.bio.split('\\n\\n').map((paragraph, index) => (
      <p key={index} className="mb-4">
      {paragraph}</p>
      ))}
    </div>*/
  );
}
